//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '@/mixins/global'
import axios from 'axios'

export default {
  data () {
    return {
      uid: '',
      password: '',
      isPwd: true,
      bar2: false,
      email: '',
      empcode: '',
      date: ''
    }
  },
  created () {
    this.CheckLocal()
    this.CurrDate()

    setTimeout(() => {
      console.log(this.$api)
      console.log(this.$apiAuthen)
    }, 1000)
  },
  beforeMount () {
    let price = {
      data: null
    }
    let a = price.data || 'No data'
    console.log(a)
    // merce array
    let arrA = [1, 2, 3, 4]
    let arrB = ['A', 'B', 'C']
    let newArr = arrA.concat(arrB)
    console.log(newArr)
    // uniq in array
    let arrC = ['A', 'B', 'C', 'C', 'F']
    let newarrc = [...new Set(arrC)]
    console.log(newarrc)
    // check object
    let obj = {
      name: null,
      age: null,
      sex: null
    }
    console.log(Object.keys(obj).length)
  },
  mounted: function () {
    this.$store.commit('setAuthen', false)
    this.$store.commit('setKey', '')
    this.$store.commit('setUID', '')
    this.$store.commit('setUUID', '')
    this.$store.commit('setOU', '')
    this.$store.commit('setBU', '')
    this.$store.commit('setTeam', '')
    this.$store.commit('setTtime', '')
  },
  methods: {
    // CheckAPI: function () {
    //     var output = ''
    //     axios({
    //             method: 'get',
    //             url: 'http://172.16.9.20:85/authen/signin.php/',
    //             data: {},
    //             responseType: 'json',
    //         })
    //         .then(function (response) {
    //             console.log(response.data)
    //             output = 'http://172.16.9.20:85/nygcontrolroom/'
    //         }.bind(this))
    //         .catach(function (error) {
    //             output = 'http://webalert.nanyangtextile.com:85/nygcontrolroom/'
    //         })
    //     console.log(output)
    //     return output
    // },

    // async fetchData(enpoint) {
    //     const res = await fetch(enpoint)
    //     let data = await res.json()
    //     return data
    // },

    // async f() {

    //     try {
    //         let response = await fetch('http://172.16.9.20:85/authen/signin.php/');
    //         let user = await response.json();
    //         this.urlapi = this.apiLocal()
    //     } catch (err) {
    //         // catches errors both in fetch and response.json
    //         console.log(err);
    //         this.urlapi = this.apiPublic()
    //     }
    // },

    // async f() {

    //     try {
    //         let response = await fetch('http://172.16.9.20:85/authen/signin.php/');
    //     } catch (err) {
    //         console.log(err); // TypeError: failed to fetch
    //     }
    // },

    // getAPI3() {
    //     try {
    //         let params = new FormData()
    //         axios({
    //             method: "get",
    //             url: 'http://172.16.9.20:85/authen/signin.php/1',
    //             data: params
    //         }).then(res => {
    //             console.log(res.data)
    //         })
    //     } catch (error) {

    //     }

    // },

    // async getAPI2() {
    //     try {
    //         const response = await axios.get('http://172.16.9.20:85/authen/signin.php/');
    //         // Success 🎉
    //         this.local = true
    //         console.log(response);
    //     } catch (error) {
    //         // Error 😨
    //         if (error.response) {
    //             console.log(error.response.data);
    //             console.log(error.response.status);
    //             console.log(error.response.headers);
    //         } else if (error.request) {
    //             console.log(error.request);
    //         } else {
    //             console.log('Error', error.message);
    //         }
    //         console.log(error);
    //     }
    //     console.log(this.local)
    // },

    CurrDate () {
      let params = new FormData()
      axios({
        method: 'post',
        url: this.$api + 'master.php/curdate',
        data: params
      }).then(res => {
        this.date = res.data.dte
      })
    },

    testapi () {
      let params = new FormData()
      params.append('uid', this.uid)
      params.append('pwd', this.password)
      axios
        .post('http://127.0.0.1:9000/qn/authen.php/test2', params)
        .then(response => {
          console.log(response.data)
          console.log(response.status)
        })
        .catch(err => {
          console.error(err)
        })
    },

    signin () {
      if (this.uid === '' || this.password === '') {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: 'Please fill Username and Password!',
          html: true
        })
        return false
      }
      try {
        this.$q.loading.show()
        let uuid = this.create_UUID()
        let params = new FormData()
        params.append('uid', this.uid)
        params.append('pwd', this.password)
        params.append('syscode', 'CTRNYG')
        params.append('uuid', uuid)
        // params.append("url", url)
        axios({
          method: 'post',
          // url: this.$apiAuthen + "signin.php/signin_syscode_room",
          url: 'https://webalert.nanyangtextile.com/authen/signin.php/signin_syscode_room',
          data: params
        }).then(res => {
          // console.log(res.data)
          // console.log(this.$store.getters.uid)
          // console.log(this.$store.getters.team)
          if (res.data.authen === false) {
            this.$q.notify({
              position: 'top-right',
              timeout: 2500,
              textColor: 'white',
              color: 'red',
              message: 'Username or Password is fail!',
              html: true
            })
            this.$q.loading.hide()
          } else {
            console.log(res.data)
            this.$store.commit('setAuthen', true)
            this.$store.commit('setTeam', res.data.TEAM_NAME)
            this.$store.commit('setUID', res.data.uid)
            this.$store.commit('setTtime', this.date)
            this.$store.commit('setUUID', uuid)
            // if (this.local) {
            //     this.$store.commit("setAPI", "http://172.16.9.20:85/nygcontrolroom/");
            // } else {
            //     this.$store.commit("setAPI", "http://webalert.nanyangtextile.com:85/nygcontrolroom/");
            // }
            this.getReadinessProcess()
            this.$q.loading.hide()
          }
        })
      } catch (err) {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: err,
          html: true
        })
        this.$q.loading.hide()
      }
    },

    RequestPassword () {
      let email = this.email + '@nanyangtextile.com'
      let uid = this.empcode

      if (this.email === '' && this.empcode === '') {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: 'Please Email or Employee Code!',
          html: true
        })
        return false
      }
      let params = new FormData()
      params.append('email', email)
      params.append('uid', uid)
      axios({
        method: 'post',
        url: 'http://qbi.nanyangtextile.com:8080/losspassword',
        data: params
      }).then(res => {
        if (res.data.count > 0) {
          this.$q.notify({
            position: 'top-right',
            timeout: 2500,
            textColor: 'white',
            color: 'green',
            message: 'Please check email for user and password',
            html: true
          })
          this.bar2 = false
          this.email = ''
          this.empcode = ''
        } else {
          this.$q.notify({
            position: 'top-right',
            timeout: 2500,
            textColor: 'white',
            color: 'red',
            message: 'User not found!',
            html: true
          })
          this.email = ''
          this.empcode = ''
        }
      })
    },
    // create_UUID() {
    //   var dt = new Date().getTime();
    //   var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    //     var r = (dt + Math.random() * 16) % 16 | 0;
    //     dt = Math.floor(dt / 16);
    //     return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    //   });
    //   return uuid;
    // },
    getReadinessProcess () {
      // console.log(this.$store.getters.uuid)
      let params = new FormData()
      params.append('uid', this.uid)
      axios({
        method: 'post',
        url: this.$api + 'master.php/ProcessView',
        data: params
      }).then(res => {
        console.log(res.data)
        this.$store.commit('setProcess', res.data)

        this.$router.replace({
          name: 'MainGroup',
          query: {
            uid: this.create_UUID()
          }
        })
      })
    },

    alert () {
      this.$q
        .dialog({
          dark: true,
          title: 'Alert',
          message: 'Some message'
        })
        .onOk(() => {
          // console.log('OK')
        })
        .onCancel(() => {
          // console.log('Cancel')
        })
        .onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
    }
  }
}
